export const minOddConstant = 1.01;
export const defaultMinOdd = 2;
export const minOddStep = 0.1;
export const autoBetCounts = [5, 10, 20, 50, 99];
